import axios from "axios";

const API = {
  getZipcode: function (zipcode) {
    return axios.get(`https://api.zippopotam.us/us/${zipcode}`);
  },
};
export default API;
